import { createContext } from 'react';

const MappedActionContext = /*#__PURE__*/createContext({});

export { MappedActionContext };
